<script lang="ts" setup>
import { useIsMobile } from "@/assets/js/helpers";
import { useProfileStore } from "@/store/profile";

definePage({
	name: "teacher.profile.working-experience",
	meta: {
		returnToTop: true,
	},
});

const profileStore = useProfileStore();
function handleSave(data, index) {
	if (data.ongoing && !data.cve_end) data.cve_end = "3000-01-01";
	for (const key in data) {
		profileStore.profileChanges.experiences.PEXP[index][key] = data[key];
	}
}
const isMobile = useIsMobile();

watch(
	() => profileStore.profileChanges?.experiences,
	(experiences) => {
		if (experiences) {
			const pexp = experiences.PEXP;
			if (!pexp || pexp.length < 1) {
				profileStore.addNewExperienceItem("PEXP");
			}
		}
	},
	{ immediate: true },
);
</script>
<template>
	<div>
		<div
			v-if="isMobile"
			class="sub-title-profile-page"
		>
			{{ $t("app.base.step") }} 4 |
			{{ $t("app.teacher.profileStepper.working-experience") }}
		</div>
		<info-icon
			class="help-icon-profile-page"
			:text="$t('app.teacher.profile.workingExperienceHelperText')"
		/>
		<!-- <label
			class="sub-title"
			:class="{ 'with-padding': isMobile }"
		>
			{{ $t("app.teacher.profileStepper.working-experience") }}
		</label> -->
		<div
			v-if="isMobile && profileStore.profileChanges.experiences?.PEXP?.length"
			class="teacher-profile-fake-circle"
		></div>
		<transition-group
			name="fade-down"
			tag="div"
			class="teacher-profile-experience-wrap"
		>
			<cv-item
				v-for="(item, index) in profileStore.profileChanges.experiences?.PEXP"
				:key="item.cve_id"
				:title="
					$t('app.teacher.profile.nonTeachingJob', { number: index + 1 }, 2)
				"
				:data="item"
				type="PEXP"
				@save="handleSave($event, index)"
				@remove="profileStore.profileChanges.experiences.PEXP.splice(index, 1)"
			></cv-item>
		</transition-group>
		<soft-button
			class="light-button-add-fix"
			@click="profileStore.addNewExperienceItem('PEXP')"
		>
			<template #icon>
				<i-ic-outline-add-box />
			</template>
			<template #default>
				<span
					v-if="
						!profileStore.profileChanges?.experiences?.PEXP ||
						profileStore.profileChanges.experiences.PEXP.length === 0
					"
				>
					{{
						$t("app.base.add", {
							item: $t("app.teacher.profile.nonTeachingJob").toLowerCase(),
						})
					}}
				</span>
				<span v-else>
					{{
						$t("app.base.addAnother", {
							item: $t("app.teacher.profile.nonTeachingJob").toLowerCase(),
						})
					}}
				</span>
			</template>
		</soft-button>
	</div>
</template>
